import ActionType from 'actions/ActionType'

const newPhoneNumber = {
  phone_number: 'New phone number',
  number_formatted: 'New phone number',
}

export default (
  state = {
    acquireNumberDisplayed: false,
    // areaCodeValue: '',
    availablePhoneNumbers: [newPhoneNumber],
    selectedPhoneNumber: 'New phone number',
    selectedUseCase: 'Select use case',
    defaultNumber: null,
  },
  action,
) => {
  switch (action.type) {
    // case ActionType.PhoneNumbers.CHANGE_AREA_CODE:
    //   return {
    //     ...state,
    //     areaCodeValue: action.payload,
    //   }
    case ActionType.Data.LIST_SUCCESS:
      if (
        action.entityType === 'phonenumbers' &&
        Array.isArray(action.payload)
      ) {
        const defaultPhone = action.payload.find(element => element.default)
        if (defaultPhone) {
          return { ...state, defaultNumber: defaultPhone.phone_number }
        }
        return state
      }

      if (
        action.entityType === 'a2p10dlc' &&
        Object.keys(action.payload?.[0]?.campaigns || {})?.length
      ) {
        const campaignKeys = Object.keys(action.payload?.[0]?.campaigns)

        if (campaignKeys?.length > 1 && campaignKeys.includes('LOW_VOLUME')) {
          return { ...state, selectedUseCase: 'LOW_VOLUME' }
        } else {
          return { ...state, selectedUseCase: campaignKeys[0] }
        }
      }

      return state
    case ActionType.Data.UPDATE_SUCCESS:
      if (action.entityType === 'phonenumbers') {
        if (action.payload.default) {
          return { ...state, defaultNumber: action.payload.phone_number }
        }
        return state
      }
      return state
    case ActionType.Data.CREATE_SUCCESS:
      if (action.entityType === 'phonenumbers') {
        if (action.payload.default) {
          return { ...state, defaultNumber: action.payload.phone_number }
        }
      }
      return state
    case ActionType.PhoneNumbers.SELECT_NEW_PHONE_NUMBER:
      return {
        ...state,
        selectedPhoneNumber: action.payload,
      }
    case ActionType.PhoneNumbers.TOGGLE_ACQUIRE_NUMBER_DISPLAY:
      return {
        ...state,
        acquireNumberDisplayed:
          typeof action.payload === 'boolean'
            ? action.payload
            : !state.acquireNumberDisplayed,
      }
    case ActionType.PhoneNumbers.SELECT_USE_CASE:
      return {
        ...state,
        selectedUseCase: action.payload,
      }
    case ActionType.PhoneNumbers.SEARCH_AVAILABLE_PHONE_NUMBERS_SUCCESS:
      const availablePhoneNumbers = action.payload
        ? [newPhoneNumber, ...action.payload]
        : [newPhoneNumber]

      return {
        ...state,
        availablePhoneNumbers,
      }
    default:
      return state
  }
}
